import React from 'react';
import {
  Users, FolderKanban, Calculator, ShoppingCart, Truck, Video, ShieldCheck,
  Megaphone, BookOpen, BookOpenText, Briefcase, GraduationCap, Send, Tag, FileText, CalendarDays,
} from 'lucide-react';
import SectionHubLayout from '@/components/SectionHubLayout';
import useNotificationCounts from '@/hooks/useNotificationCounts';

const BRAND = {
  name: 'ProBound',
  fullName: 'Ox Resin ProBound',
  tagline: 'Resin Bound Surfacing',
  primaryColor: '#2F5E96',
  secondaryColor: '#300122',
  sectionKey: 'probound',
  logo: 'https://customer-assets.emergentagent.com/job_resin-quote-calc/artifacts/0yxgnasw_IMG_8077.jpeg',
};

const CATEGORIES = [
  {
    id: 'leads-marketing',
    title: 'Leads & Marketing',
    description: 'Win new work and promote your business',
    icon: Megaphone,
    tiles: [
      { id: 'lead-offers', title: 'Lead Offers', description: 'New ProBound leads offered to you', icon: Send, path: '/lead-offers?section=probound', notifKey: 'offer' },
      { id: 'leads', title: 'Lead Management', description: 'Track ProBound enquiries through to project', icon: Users, path: '/probound/leads', notifKey: 'lead' },
    ],
  },
  {
    id: 'quotes-projects',
    title: 'Quotes & Project Management',
    description: 'Quote, order and deliver',
    icon: Briefcase,
    tiles: [
      { id: 'quote-project', title: 'Customer Quotes', description: 'Start, resume or review project quotes', icon: Calculator, path: '/my-quotes' },
      { id: 'my-orders', title: 'Material Orders', description: 'Build new orders, view pricing & track delivery', icon: Truck, path: '/probound/my-orders', notifKey: 'order' },
      { id: 'projects', title: 'Project Management', description: 'Track active ProBound projects', icon: FolderKanban, path: '/probound/projects' },
      { id: 'calendar', title: 'Project Calendar', description: 'Plan your weeks — allocate install stages to days across all jobs', icon: CalendarDays, path: '/probound/calendar' },
    ],
  },
  {
    id: 'training-development',
    title: 'Training & Professional Development',
    description: 'Learn the craft and earn the badge',
    icon: GraduationCap,
    tiles: [
      { id: 'videos', title: 'Training Videos', description: 'Tips, tricks & install techniques', icon: Video, path: '/videos/probound' },
      { id: 'course-notes', title: 'Course Notes & Training Material', description: 'Course handbook PDF · download or read inline', icon: BookOpenText, path: '/notes/probound' },
      { id: 'get-approved', title: 'Become OxApproved', description: 'Track your ProBound approval status', icon: ShieldCheck, path: '/approval/probound' },
    ],
  },
  {
    id: 'toolbox',
    title: 'Toolbox',
    description: 'Marketing kit, calculators & letter templates',
    icon: BookOpen,
    tiles: [
      { id: 'marketing', title: 'Marketing Material', description: 'Branded leaflets, posters, social assets', icon: BookOpen, path: '/marketing-materials?section=probound' },
      { id: 'calculators', title: 'Calculators', description: 'MOT, tarmac, porous concrete, blocks & useful docs', icon: Calculator, path: '/toolbox?brand=probound' },
      { id: 'templates', title: 'Templates', description: 'Quote letters, RAMS, customer emails, T&Cs, warranty & aftercare', icon: FileText, path: '/templates?brand=probound' },
    ],
  },
];

const ProBoundHub = () => {
  const { bySectionCategory: notifBSC } = useNotificationCounts();
  return (
    <SectionHubLayout
      brand={BRAND}
      categories={CATEGORIES}
      testIdPrefix="probound"
      notifBSC={notifBSC}
    />
  );
};

export default ProBoundHub;
